export default __webpack_public_path__ + "static/media/proof329.3f55dd66.png";